<div class="tts" role="status" aria-live="polite">
  <span class="tts__glyph" aria-hidden="true">◍</span>

  <span class="tts__meter" aria-hidden="true">
    <span class="tts__bar" *ngFor="let bar of bars; let i = index" [style.animation-delay.ms]="i * 100"></span>
  </span>

  <span class="tts__state">speaking · {{ rateLabel }}</span>

  <button type="button" class="tts__stop" (click)="stopped.emit()">stop</button>
</div>
